import removeDuplicatesFromUserVoiceData from '../telemetry/removeDuplicatesFromUserVoiceData';
import { TxpObject } from 'txp-data';

export default function getActivityNames(txpObject: TxpObject): string {
    if (txpObject && txpObject.txpActivities) {
        let activityNames = txpObject.txpActivities.map(activity => activity.activityName);
        return removeDuplicatesFromUserVoiceData(activityNames);
    } else {
        return null;
    }
}
